import { Injectable } from '@angular/core';


const tokenkey = 'authtoken';
const tokenLifeTime = 'lifeTime';
const rulekey = 'ruletoken';

@Injectable()
export class TokenStorage {

  constructor() { }

  signOut() {
    window.localStorage.removeItem(tokenkey);
    window.localStorage.removeItem(rulekey);
    window.localStorage.clear();
  }

  public saveToken(token: string) {
    window.localStorage.removeItem(tokenkey);
    window.localStorage.setItem(tokenkey, JSON.stringify(token));

    window.localStorage.removeItem(tokenLifeTime);
    var date = new Date;
    date.setDate(new Date().getDate() + 1 );
    window.localStorage.setItem(tokenLifeTime, date.toISOString());
  }

  public getToken(): any {
    console.debug();
    const  token = window.localStorage.getItem(tokenkey);
    return JSON.parse(token);
  }

  public setRole(role): any {
    window.localStorage.removeItem(rulekey);
    window.localStorage.setItem(rulekey,JSON.stringify(role));
  }

  public getRole(): string {
    const  rules = window.localStorage.getItem(rulekey);
    return rules;
  }

  public getTokenLifeTime(): any {
    return window.localStorage.getItem(tokenLifeTime);
  }

  public isChiefRole(): boolean {
    const  role = window.localStorage.getItem(rulekey);

    if (role.includes("administrator") || role.includes("office") || role.includes("federalmanager") || role.includes("commercialdirector")) {
      return true;
    }
    else {
      return false;
    }
  }

  public isFM(): boolean {
    const  role = window.localStorage.getItem(rulekey);
    
    return role.includes("federalmanager");
  }

  public isCD(): boolean {
    const  role = window.localStorage.getItem(rulekey);

    return role.includes("commercialdirector");
  }


}



// WEBPACK FOOTER //
// ./src/app/storages/token.storage.ts